Object.assign = require('object-assign')



// WEBPACK FOOTER //
// ./src/utils/polyfills.js